namespace Riepiloghi.Administration {
    export interface UserListRequest extends Serenity.ListRequest {
    }
}
